import {getPaymentLink} from "@/api/Orders/GetPaymentLink";
import {createOrder} from "@/api/Orders/CreateOrder";
import {getOrderStatusByCourseId} from "@/api/Orders/GetOrderStatusByCourseId";
import {getOrderStatus} from "@/api/Orders/GetOrderStatus";

export default {
    actions: {
        fetchPaymentLink: async ({commit}, {locationId, orderIdentifier, origin, customersCourseToExtendId}) => {
            const paymentLink = await getPaymentLink(locationId, orderIdentifier, origin, customersCourseToExtendId)
            return paymentLink.data
        },
        createOrder: async ({commit}, {locationId, productId, greenCourseId, isCourseExtension = false, customersCourseId}) => {
            const order = await createOrder(locationId, productId, greenCourseId, isCourseExtension, customersCourseId);
            return order.data
        },
        getOrderStatus: async ({commit}, {orderIdentifier}) => {
            const status = await getOrderStatus(orderIdentifier)
            return status.data
        },
        getOrderStatusByCourseId: async ({commit}, {customersCourseId}) => {
            console.log("courseEndedView", customersCourseId)
            const status = await getOrderStatusByCourseId(customersCourseId)
            return status.data
        }
    }
}

